/**
 * Aircraft Type API
 *
 * RTK Query endpoints for aircraft type autocomplete operations
 */

import { baseApi } from './baseApi';

export interface AircraftTypeAutocomplete {
  aircraftType: string;
  aircraftGroup: string;
  manufacturer: string;
  model: string;
  variant: string;
  icaoCode: string;
}

export const aircraftTypeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Autocomplete endpoint - Optimized for dropdowns
     * Returns lightweight data for aircraft type search
     */
    autocompleteAircraftTypes: builder.query<AircraftTypeAutocomplete[], { query: string; limit?: number }>({
      query: ({ query, limit = 10 }) =>
        `/aircraft-types/autocomplete?q=${encodeURIComponent(query)}&limit=${limit}`,
      keepUnusedDataFor: 300,
    }),
  }),
});

export const {
  useAutocompleteAircraftTypesQuery,
  useLazyAutocompleteAircraftTypesQuery,
} = aircraftTypeApi;
